module.exports = __webpack_public_path__ + "img/clock-timeout.284518f7.png";